// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"949721b9","47":"11e35520","101":"81c8cde3","111":"4a1ad8e3","176":"bfecefb0","225":"4ea17494","233":"db81845d","322":"d905b309","395":"78cabc79","587":"8c13545a","654":"94de7b51","738":"ba80dce1","775":"7656344c","870":"6334a682","948":"602b4648","975":"2104197c"}[chunkId] + ".chunk.js";
};